/** C-03 §11.1.2 API 프록시 prefix 상수 */
export const API_PRX = {
  MEMBER:     '/member',
  CUSTOMER:   '/customer',
  INDIPIA:    '/indipia',
  FLOORPLAN:  '/floorplan',
  WORKLOG:    '/worklog',
  PHOTO:      '/photo',
  PORTFOLIO:  '/portfolio',
  CHAT:       '/chat',
  SUPPORT:    '/support',
} as const;
